import styled from "styled-components";

export const Container = styled.div`
  margin-top: 2vh;
`;
export const StyledHeader = styled.header`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-bottom: 16px;
  gap: 16px;
`;
